import { createActionCreators } from 'immer-reducer';

import { WorkspaceReducer } from '@/store/reducers/workspace';

export const workspaceActions = createActionCreators(WorkspaceReducer);

export type AuthActions =
  | ReturnType<typeof workspaceActions.setCurrentGarage>;
